
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["feather feather-corner-left-up",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round","class":"feather feather-corner-left-up"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14 9L9 4 4 9"}}),_c('path',{attrs:{"d":"M20 20h-7a4 4 0 01-4-4V4"}})])
          )
        }
      }
    